import { Typography } from "@mui/material";
import React from "react";
import { CustomerInterface } from "../../Objects/Customer";

export interface MembershipCodeProps {
    customerData: CustomerInterface
}

const MembershipCode: React.FC<MembershipCodeProps> = ({
    customerData
}) => {
    return (
        <>
            <Typography variant="body2" align="right">
                会員番号：{customerData.code ? customerData.code : "未入会"}
            </Typography>
            <Typography variant="body2" align="right">
                {customerData.old_member_id ? "（旧会員番号："+customerData.old_member_id+"）" : ""}
            </Typography>
        </>
    );
}

export default MembershipCode